import React from 'react'
import KarteraThemeSwitch from '../../../template/kartera/KarteraThemeSwitch'
import { useLegalTermsModel } from './legal-terms-model'

const LegalTerms = () => {
    const model = useLegalTermsModel()

    return (
        <div className="k-root min-h-dvh bg-k-bg px-[clamp(20px,4vw,48px)] py-8 font-kartera text-k-ink">
            <div className="mx-auto flex w-full max-w-[880px] flex-col gap-6">
                <header className="flex items-center justify-between gap-4">
                    <div/>
                    <KarteraThemeSwitch compact />
                </header>

                <div className="flex items-center gap-3.5">
                    <img src="/brand/kartera365-icon.png" alt="Kartera 365" className="h-12 w-12 rounded-xl" />
                    <div className="flex flex-col gap-0.5">
                        <h1 className="m-0 text-[28px] font-extrabold tracking-[-0.03em]">{model.title}</h1>
                        <p className="m-0 text-sm text-k-muted">Condiciones de uso del servicio.</p>
                    </div>
                </div>

                <nav aria-label="Contenido" className="k-card">
                    <h2 className="k-card-title">Contenido</h2>
                    <ol className="m-0 grid list-none grid-cols-1 gap-x-6 gap-y-1.5 p-0 sm:grid-cols-2">
                        {model.index.map((item, index) => (
                            <li key={item.id}>
                                <a href={`#${item.id}`} className="inline-flex gap-2 text-sm text-k-ink-2 hover:text-brand-indigo">
                                    <span className="w-5 shrink-0 text-right font-bold tabular-nums text-k-muted">{index + 1}.</span>
                                    {item.title}
                                </a>
                            </li>
                        ))}
                    </ol>
                </nav>

                <article className="k-card gap-7">
                    {model.sections.map((section, index) => (
                        <section key={section.id} id={section.id} className="flex scroll-mt-6 flex-col gap-3">
                            <h2 className="m-0 flex items-baseline gap-2 text-lg font-extrabold tracking-[-0.01em] text-k-ink">
                                <span className="tabular-nums text-k-muted">{index + 1}.</span>
                                {section.title}
                            </h2>
                            {section.paragraphs.map((parts, paragraphIndex) => (
                                <p key={paragraphIndex} className="m-0 text-[15px] leading-[1.7] text-k-ink-2">
                                    {parts.map((part, partIndex) => (part.type === 'email'
                                        ? <a key={partIndex} href={`mailto:${part.value}`} className="font-semibold text-k-primary-ink hover:underline">{part.value}</a>
                                        : <React.Fragment key={partIndex}>{part.value}</React.Fragment>))}
                                </p>
                            ))}
                        </section>
                    ))}
                </article>
            </div>
        </div>
    )
}

export default LegalTerms
